<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-card class="mb-5">
      <v-card-title>
        <v-container>
          <v-row>
            <v-col cols="12" md="1" class="mr-5">
              Invoice
            </v-col>
            <v-col cols="12" md="2" class="mr-5">
              <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                  v-if="selectedButtonType === 'totalInvoiceData'|| selectedButtonType === 'allRefundData' || selectedButtonType === 'internalReferralData'"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="date"
                      label="Select Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      hide-details
                      outlined
                      dense
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="date"
                    @input="menu2 = false"
                    @click:date="dateSelect"
                    :max="nowDate"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="2" class="me-5" v-if="selectedButtonType === 'totalInvoiceData'">
              <v-autocomplete
                  v-model="invoiceFilterType"
                  :items="filterInvoiceType"
                  label="Invoice Type"
                  single-line
                  hide-details
                  outlined
                  dense
                  clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="2" class="me-5">
              <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                  outlined
                  dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" class="me-2">
              <v-row align="center" justify="center">
                <v-col cols="auto" v-if="selectedButtonType === 'totalInvoiceData'">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                          depressed
                          color="primary"
                          v-on="on"
                          v-on:click="printList"
                      >
                        <v-icon>mdi-printer</v-icon>
                      </v-btn>
                    </template>
                    <span>Print Self</span>
                  </v-tooltip>
                </v-col>
                <v-col cols="auto" v-if="selectedButtonType === 'totalInvoiceData'">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                          depressed
                          color="warning"
                          v-on="on"
                          v-on:click="printListAll"
                      >
                        <v-icon> mdi-printer-settings</v-icon>
                      </v-btn>
                    </template>
                    <span>Print All User</span>
                  </v-tooltip>
                </v-col>
                <v-col cols="auto" v-if="selectedButtonType === 'invoiceDue'">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                          depressed
                          small
                          color="info"
                          v-on="on"
                          v-on:click="DuePrintList"
                      >
                        <v-icon> mdi-printer</v-icon>
                      </v-btn>
                    </template>
                    <span>Due List Print</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card-title>
    </v-card>
    <v-card>
      <v-container>
        <v-row>
          <v-col cols="12" md="7" sm="12" class="mr-5">
            <div class="statusClass">
              <div v-for="(button, index) in AllButtonTypes" :key="index">
                <v-btn
                    style="font-size: 14px"
                    class="text-none mr-2 mt-1 mb-1"
                    medium
                    :color="isSelected(button.buttonType) ? DataButtonColor(button.buttonType) : 'default'"
                    @click="selectButton(button.buttonType)"
                >
                  <v-icon :color="isSelected(button.buttonType) ? 'warning' : 'blue'">{{ button.icon }}</v-icon>
                  {{ button.title }}
                  <template v-if="button.buttonType === 'totalInvoiceData'">
                    ({{ totalCount.totalInvoiceCount || 0 }})
                  </template>
                  <template v-else-if="button.buttonType === 'invoiceDue'">
                    ({{ totalCount.totalInvoiceDueCount || 0 }})
                  </template>
                  <template v-else-if="button.buttonType === 'allRefundData'">
                    ({{ totalCount.totalInvRefundCount || 0 }})
                  </template>
                  <template v-else-if="button.buttonType === 'internalReferralData'">
                    ({{ totalCount.totalIntReferCount || 0 }})
                  </template>
                </v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4" sm="12" class="mr-5">
            <div class="statusClass" v-if="selectedButtonType === 'totalInvoiceData'">
              <div v-for="(invoice_type, index) in typeWiseCounts" :key="index">
                <v-chip
                    color="primary"
                    text-color="warning"
                    class="ma-2"
                    outlined
                    small
                >
                  {{ invoice_type.invoice_type.toUpperCase() }} ({{ invoice_type.count }})
                </v-chip>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <v-data-table
          :headers="headers"
          :items="itemsWithSno"
          class="elevation-1"
          :search="search"
          dense
          :loading="loadingStatus"
          loading-text="Loading... Please wait"
      >
        <template v-slot:item.status="{ item }">
          <v-chip :color="getColor(item.status)" dark>
            {{ item.status.toUpperCase() }}
          </v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip top v-if="selectedButtonType === 'internalReferralData'">
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                  @click="internal_referral_prescription(item)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                  label
                  outlined
                  small
              >
                <v-icon> mdi-prescription</v-icon>
              </v-chip>
            </template>
            <span>Ref Prescription Print</span>
          </v-tooltip>
          <v-tooltip top v-if="item.invoice_type === 'consultation'">
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                  @click="prescription_print(item)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  open
                  prepend-icon="mdi mdi-prescription"
                  color="warning"
                  label
                  outlined
                  small
              >
                <v-icon>mdi mdi-prescription</v-icon>
              </v-chip>
            </template>
            <span>Prescription Print</span>
          </v-tooltip>
          <v-tooltip top >
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                  @click="invoice_new_print(item)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  open
                  prepend-icon="mdi-printer"
                  color="success"
                  label
                  outlined
                  small
              >
                <v-icon> mdi-printer</v-icon>
              </v-chip>
            </template>
            <span>Invoice Print New</span>
          </v-tooltip>
          <v-tooltip top
                     v-if="selectedButtonType === 'totalInvoiceData' && item.invoice_type === 'consultation' && item.inv_date === nowDate &&  item.status !== 'void'">
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                  @click="internalReferral(item)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  open
                  prepend-icon="mdi-transfer"
                  color="info"
                  label
                  outlined
                  small
              >
                <v-icon>mdi-transfer</v-icon>
              </v-chip>
            </template>
            <span>Internal Referral</span>
          </v-tooltip>
          <v-tooltip top v-if="item.invoice_type === 'consultation' &&  item.status !== 'void' || item.invoice_type === 'investigation'  &&  item.status !== 'void'  " >
            <template v-slot:activator="{ on, attrs }" v-if="item.inv_date === nowDate">
              <v-chip
                  @click="invoice_refund(item)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  open
                  prepend-icon="mdi-printer"
                  color="warning"
                  label
                  outlined
                  small
              >
                <v-icon>mdi-cash-refund</v-icon>
              </v-chip>
            </template>
            <span>Invoice Refund</span>
          </v-tooltip>
          <v-tooltip top v-if="item.has_specific_ffa >= 1">
            <template v-slot:activator="{ on, attrs }" >
              <v-chip
                  @click="ffa_undertaken(item)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  open
                  color="primary"
                  label
                  outlined
                  small
              >
                <v-icon> mdi-message-text</v-icon>
              </v-chip>
            </template>
            <span>FFA (Undertaken)</span>
          </v-tooltip>
          <v-tooltip top v-if="item.status == 'due' ">
            <template v-slot:activator="{ on, attrs }" v-if="selectedButtonType === 'invoiceDue' &&  item.status !== 'void'">
              <v-chip
                  @click="invoice_due_collect(item)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  open
                  color="green"
                  label
                  outlined
                  small
              >
                <v-icon left> mdi-inbox</v-icon>
              </v-chip>
            </template>
            <span>Due Collect</span>
          </v-tooltip>
          <v-tooltip top
                     v-if="item.refund_date == nowDate &&  selectedButtonType === 'allRefundData' && item.status !== 'void' ">
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                  @click="revoke_invoice(item)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  open
                  color="green"
                  label
                  outlined
                  small
              >
                <v-icon left> mdi-account-arrow-right</v-icon>
              </v-chip>
            </template>
            <span>Revoke</span>
          </v-tooltip>
          <v-tooltip top
                     v-if=" selectedButtonType === 'internalReferralData' &&  item.status !== 'void'">

            <template
                v-slot:activator="{ on, attrs }" v-if="item.date == nowDate"
            >
              <v-chip
                  @click="editInternalReferral(item)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                  label
                  outlined
                  small
              >
                <v-icon>mdi-tooltip-edit</v-icon>
              </v-chip>
            </template>
            <span>Edit Internal Referral</span>
          </v-tooltip>
          <v-tooltip top
                     v-if="selectedButtonType === 'internalReferralData' && item.status !== 'void'">
            <template
                v-slot:activator="{ on, attrs }"
                v-if="item.date == nowDate"
            >
              <v-chip
                  @click="internalReferralRemove(item)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  color="warning"
                  label
                  outlined
                  small
              >
                <v-icon> mdi-trash-can-outline</v-icon>
              </v-chip>
            </template>
            <span>Remove Referral</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <template>
        <v-row justify="center">
          <v-dialog v-model="dialog" persistent max-width="500">
            <v-card>
              <v-form @submit.prevent="internalReferralUpdate()" ref="form">
                <v-card-title class="text-h5">
                  Internal Referral Edit
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <template>
                    <v-simple-table dense>
                      <template v-slot:default>
                        <tbody>
                        <tr>
                          <td>Patient ID</td>
                          <td>{{ editData.patient_id }}</td>
                        </tr>
                        <tr>
                          <td>Patient Name</td>
                          <td>{{ editData.patient.patient_name }}</td>
                        </tr>
                        <tr>
                          <td>Doctor Name</td>
                          <td>
                            {{ editData.refer_doctor.dr_name }}
                          </td>
                        </tr>
                        <tr>
                          <td>Referral Doctor Name</td>
                          <td>
                            <template>
                              <v-autocomplete
                                  :items="doctors"
                                  color="white"
                                  item-text="dr_name"
                                  item-key="id"
                                  label="Doctor List"
                                  v-model="internal_ref_to_doctor"
                                  cols="3"
                                  sm="6"
                                  solo
                                  return-object
                                  :loading="loadingStatus"
                              ></v-autocomplete>
                            </template>
                          </td>
                        </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </template>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="green darken-1" text @click="dialog = false">
                    Cancel
                  </v-btn>
                  <v-btn color="green darken-1" depressed type="submit">
                    Update
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
      <template>
        <div class="text-center">
          <v-dialog v-model="internalDialog" width="750">
            <v-card :loading="loadingStatus">
              <v-card-title class="text-h5 grey lighten-2"> Internal Referral Transfer
                [{{ internalReferSubmit.invoice_id }}]
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row no-gutters class="mt-1">
                    <v-col md="6" class="mr-1">
                      <v-autocomplete
                          v-model="internalReferSubmit.refer_dr_to_id"
                          :items="doctors"
                          item-text="dr_name"
                          item-value="id"
                          required
                          label="Refer To Internal Doctor"
                          outlined
                          dense
                          chips
                          hide-details
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <h4 class="mt-1" style="color: black">Patient Information</h4>
                  <v-row no-gutters class="mt-1">
                    <v-col md="2"><p style="color:black;">Patient ID:</p></v-col>
                    <v-col md="3" class="mr-1">
                      <v-text-field
                          v-model="internalReferSubmit.patient_id"
                          outlined
                          dense
                          chips
                          hide-details
                          disabled
                      ></v-text-field>
                    </v-col>
                    <v-col md="2"><p class="text-black">Name:</p></v-col>
                    <v-col md="3">
                      <strong class="text-black" v-if="invoiceReferData.patient">{{ invoiceReferData.patient.patient_name  }}</strong>
                    </v-col>
                  </v-row>
                  <h4 class="mt-1 text-black">Doctor Information</h4>
                  <v-row no-gutters class="mt-1">
                    <v-col md="2"><p class="text-black">Doctor Name</p></v-col>
                    <v-col md="9"><p class="text-black" v-if="invoiceReferData.doctor"><b>{{ invoiceReferData.doctor.dr_name  }}</b>
                      ({{ invoiceReferData.doctor.dr_id  }})</p></v-col>
                  </v-row>
                  <h4 class="mt-1 text-black">Invoice Information</h4>
                  <v-row no-gutters class="mt-1">
                    <v-col md="2"><p class="text-black">Invoice ID:</p></v-col>
                    <v-col md="3">
                      <strong class="text-black">{{ internalReferSubmit.invoice_id }}</strong>
                    </v-col>
                    <v-col md="3"><p class="text-black">Consultation Type:</p></v-col>
                    <v-col md="3">
                      <v-chip
                          color="success"
                          v-if="invoiceReferData"
                      >{{ invoiceReferData.consultation_type }}
                      </v-chip>
                    </v-col>
                    <v-col md="2"><p class="text-black">Create date:</p></v-col>
                    <v-col md="3">
                      <strong
                          class="text-black"
                          v-if="invoiceReferData"
                      >{{ invoiceReferData.inv_date  }}</strong>
                    </v-col>
                    <v-col md="3"><p class="text-black">Status:</p></v-col>
                    <v-col md="3">
                      <v-chip
                          class="warning"
                          v-if="invoiceReferData"
                      >{{ invoiceReferData.status  }}
                      </v-chip>
                    </v-col>
                    <v-col md="2"><p class="text-black">Paid Amount:</p></v-col>
                    <v-col md="3">
                      <strong
                          class="text-black"
                          v-if="invoiceReferData"
                      >{{ invoiceReferData.paid_amount  }}</strong>
                    </v-col>
                    <v-col md="3"><p class="text-black">Discount Amount:</p></v-col>
                    <v-col md="3">
                      <strong
                          class="text-black"
                          v-if="invoiceReferData"
                      >{{ invoiceReferData.discount_amount  }}</strong>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small color="" outlined @click="internalDialog = false">
                  <v-icon>mdi-close</v-icon>
                  Close
                </v-btn>
                <v-btn small color="primary" @click="submitInternalReferDoctor">
                  <v-icon>mdi-account-check</v-icon>
                  Update
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>

      </template>
      <template>
        <div class="text-center">
          <v-dialog v-model="dialogLoading" hide-overlay persistent width="300">
            <v-card color="primary" dark>
              <v-card-text>
                Please stand by
                <v-progress-linear
                    indeterminate
                    color="white"
                    class="mb-0"
                ></v-progress-linear>
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
      </template>
    </v-card>
  </div>
</template>
<style scoped>
@media only screen and (min-width: 600px) {
  .statusClass {
    display: flex;
  }
}

.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../js/setup";
import moment from "moment";

export default {
  data() {
    return {
      date: moment().format('YYYY-MM-DD'),
      nowDate: moment().format('YYYY-MM-DD'),
      editData: {},
      dialogLoading: false,
      dialog: false,
      internalDialog: false,
      ref_to_doctor: {},
      invoiceReferData: [],
      internal_ref_to_doctor: '',
      menu2: false,
      loadingStatus: true,
      returnUrl: atshq.defaults.headers.common.app_URL,
      returnApiBaseUrl: atshq.defaults.headers.common.api_base_URL,
      search: "",
      doctors: [],
      doctor: null,
      internal_doctor: "",
      internal_doctor_to: "",
      headersConfig: {
        totalInvoiceData: [
          {
            text: "Serial #",
            value: "sno",
          },
          {text: "Invoice ID", value: "invoice_id"},
          {
            text: "Invoice Type",
            value: "invoice_type",
          },
          {
            text: "Patient ID",
            value: "patient_id",
          },

          {text: "Name", value: "patient.patient_name"},

          {text: "Doctor", value: "doctor.dr_name"},
          // { text: "Invoice", value: "sub_total" },
          {text: "Received", value: "paid_amount"},
          // { text: "Discount", value: "discount_amount" },
          {text: "Pay", value: "payment_method"},
          {text: "User", value: "user.first_name"},

          {text: "Status", value: "status"},
          {text: "Action", value: "actions", sortable: false},
        ],
        invoiceDue: [
          {text: "Serial #", value: "sno",},
          {text: "Invoice ID", align: "start", value: "invoice_id",},
          {text: "Date", value: "inv_date",},
          {text: "Invoice Type", value: "invoice_type",},
          {text: "Patient ID", value: "patient_id",},
          {text: "Patient Name", value: "patient.patient_name"},
          {text: "Due Amount", value: "due_amount"},
          {text: "Action", value: "actions", sortable: false},
        ],
        allRefundData: [
          {text: "Serial #", value: "sno",},
          {
            text: "Patient ID",
            align: "start",
            value: "patient_id",
          },
          {
            text: "OT Registration No",
            align: "start",
            value: "registration_no",
          },
          {
            text: "Invoice ID",
            value: "invoice_id",
          },
          {text: "Patient Name", value: "patient.patient_name"},
          {text: "Doctor name", value: "doctor.dr_name"},
          {text: "Doctor Ledger", value: "doctor_ledger"},
          {text: "Refund Amount", value: "refund_amount"},
          {text: "Refund Note", value: "remarks"},
          {text: "Refund By", value: "user.full_name"},

          {text: "Date", value: "create_date"},
          {text: "Action", value: "actions", sortable: false},
        ],
        internalReferralData: [
          {text: "SL", align: "start", value: "sno",},
          {text: "Invoice", value: "invoice_id",},
          {text: "Patient ID", value: "patient_id",},
          {text: "Patient Name", value: "patient.patient_name"},
          {text: "Doctor Name", value: "refer_doctor.dr_name"},
          {text: "Referral Name", value: "internal_referral_to.dr_name"},
          {text: "Referral Fee", value: "ref_to_fee"},
          {text: "Date", value: "date"},
          {text: "Action", value: "actions", sortable: false},
        ],
      },
      internalReferSubmit: {
        invoice_id: '',
        patient_id: '',
        refer_dr_to_id: '',
        user_id: localStorage.getItem("userId"),
      },
      filterInvoiceType: [],
      typeWiseCounts: [],
      totalCount: [],
      desserts: [],
      headers: [],
      invoiceFilterType: '',
      AllButtonTypes: [
        {title: 'Total Invoice', buttonType: 'totalInvoiceData', icon: 'mdi mdi-receipt-text-plus'},
        {title: 'Due List', buttonType: 'invoiceDue', icon: 'mdi mdi-receipt-text-remove'},
        {title: 'All Refunds', buttonType: 'allRefundData', icon: 'mdi mdi-cash-refund'},
        {title: 'Internal Referral', buttonType: 'internalReferralData', icon: 'mdi mdi-account-multiple-plus-outline'},
      ],
      selectedButtonType: 'totalInvoiceData',

      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Invoices",
          disabled: true,
          href: "Invoices",
        },
      ],
      user_id: localStorage.getItem("userId"),
      login_user_id: localStorage.getItem("userId"),
    };
  },
  // Fetches posts when the component is created.
  created() {
    atshq.defaults.headers.common["Authorization"] = localStorage.getItem("token");
    this.initialize(this.date);
    this.getDoctors();
  },
  watch: {
    invoiceFilterType() {
      this.initialize(this.date)
    }
  },
  computed: {
    itemsWithSno() {
      return this.desserts.map((d, index) => ({...d, sno: index + 1}));
    },
  },
  mounted() {
    this.headers = this.headersConfig[this.selectedButtonType];
  },
  methods: {
    getDoctors() {
      atshq
          .get("doctors")
          .then((response) => {
            // JSON responses are automatically parsed.
            this.doctors = response.data.data;
          })
          .catch((e) => {
            this.errors.push(e);
          });
    },

    getColor(status) {
      switch (status) {
        case 'void':
          return 'red';
        case 'due':
          return 'warning';
        default:
          return 'success';
      }
    },
    initialize(date) {
      this.loadingStatus = true;
      atshq
          .get("invoices/invoices?inv_date=" + date + "&buttonType=" + this.selectedButtonType + "&invoiceFilterType=" + this.invoiceFilterType)
          .then((response) => {
            this.loadingStatus = false;
            this.desserts = response.data.invoices;
            this.filterInvoiceType = response.data.filterInvoiceType;
            this.typeWiseCounts = response.data.typeWiseCounts;
            this.totalCount = response.data;
          })
          .catch((e) => {
            this.$noty.error(" " + e);
          });

    },

    selectButton(buttonType) {
      this.loadingStatus = true;
      this.DataButtonColor(buttonType)
      this.selectedButtonType = buttonType;
      this.headers = this.headersConfig[buttonType];
      this.initialize(this.date);
    },
    isSelected(buttonType) {
      return this.selectedButtonType === buttonType;
    },
    DataButtonColor(btnStatus) {
      switch (btnStatus) {
        default:
          return 'success';
      }
    },


    revoke_invoice(item) {
      if (confirm("are you sure?"))
        this.loadingStatus = true;
      atshq
          .post("invoices/invoice-refunds-revoke?revoke_id=" + item.id, {
            formdata: this.form,
            user_id: 1,
          })
          .then((res) => {
            if (res.status == "200") {
              this.loadingStatus = false;
              this.$noty.success(res.data.messages);
              this.initialize(this.date);
            }
          })
          .catch((e) => {
            this.$noty.error("Oops, something went wrong!");

            this.errors.push(e);
          })
          .finally(() => {
          });
    },

    internalReferralRemove(item) {
      let submitUrl = "doctor-referrals-remove/" + item.id;
      if (confirm("are you sure?")) {
        this.dialogLoading = true;
        atshq
            .put(submitUrl, {
              internal_referral_id: this.editData.id,
            })
            .then((response) => {
              this.loadingStatus = false;
              this.$noty.success(response.data.messages);
              this.initialize(this.date);
              this.dialogLoading = false;
              this.dialog = false;

            })
            .catch((e) => {
              this.$noty.error("Oops, something went wrong!");
              this.$noty.error(" " + e);
            });
      }
    },
    editInternalReferral(item) {
      this.dialog = true;
      this.editData = item;
      this.internal_ref_to_doctor = this.editData.internal_referral_to.dr_name;
    },
    internalReferralUpdate() {
      this.dialogLoading = true;
      let submitUrl = "doctor-referrals/" + this.editData.id;

      atshq
          .put(submitUrl, {
            internal_referral_to: this.internal_ref_to_doctor,
          })
          .then((response) => {
            this.loadingStatus = true;
            this.$noty.success(response.data.messages);
            this.initialize(this.date);
            this.dialogLoading = false;
            this.dialog = false;
            this.loadingStatus = false;
          })
          .catch((e) => {
            this.$noty.error("Oops, something went wrong!");
            this.$noty.error(" " + e);
          });
    },
    dateSelect(date) {
      this.loadingStatus = true;
      this.initialize(date);
    },
    internalReferral(item) {
      this.internalDialog = true;
      this.internalInvoiceData(item.invoice_id);
      this.internalReferSubmit.invoice_id = item.invoice_id;
      this.internalReferSubmit.patient_id = item.patient_id;
    },
    internalReferralDataRefresh() {
      this.internalReferSubmit.invoice_id = '';
      this.internalReferSubmit.patient_id = '';
      this.internalReferSubmit.refer_dr_to_id = '';
    },
    internalInvoiceData(invoiceId) {
      this.loadingStatus = true;
      atshq
          .get("invoices/internal-refer-invoice/" + invoiceId)
          .then((response) => {
            this.loadingStatus = false;
            this.invoiceReferData = response.data.data;
          })
          .catch((e) => {
            this.$noty.error(" " + e);
          });
    },

    submitInternalReferDoctor(){
      let submitUrl = "invoices/internal-refer-doctor-save";
      this.loadingStatus = true;
      atshq
          .post(submitUrl, {
            submitData: this.internalReferSubmit,
          })
          .then((response) => {
            this.loadingStatus = false;
            this.$noty.success(response.data.message);
            this.initialize(this.date);
            this.internalDialog = false;
            this.internalReferralDataRefresh();
            this.loadingStatus = false;

          })
          .catch((e) => {
            this.$noty.error(e.response.data.message);
            this.loadingStatus = false;
          });
    },
    invoice_print(item) {
      window.open(this.returnUrl + "printdoc/invoice/" + item.invoice_id + "/1");
    },

    invoice_new_print(item) {
      window.open(this.returnApiBaseUrl + "print/invoice/" + item.invoice_id);
    },
    prescription_print(item) {
      // window.open(this.returnUrl + "printdoc/prescription/" + item.invoice_id + "/0");
      window.open(this.returnApiBaseUrl + "print/doctor-prescription-blank/" + item.invoice_id );
    },
    internal_referral_prescription(item) {
      // window.open(this.returnUrl + "printdoc/ref_prescription/" + item.invoice_id + "/1");
      window.open(this.returnApiBaseUrl + "print/refer-doctor-prescription-blank/" + item.invoice_id );
    },
    invoice_edit(item) {
      this.$router.push("/invoice/edit/" + item.invoice_id);
    },
    invoice_refund(item) {
      this.$router.push("/invoice/refund/" + item.invoice_id);
    },
    ffa_undertaken(item) {
      window.open(this.returnUrl + "printdoc/ffa/" + item.invoice_id + "/0");
    },
    invoice_due_collect(item) {
      this.$router.push("/invoice/invoice-due-collection/" + item.invoice_id);
    },

    printList() {
      window.open(this.returnApiBaseUrl + "print/invoice-report-print?date=" + this.date +
          "&user_id=" + this.login_user_id +
          "&login_user_id=" + this.login_user_id);

    },
    printListAll() {
      window.open(this.returnApiBaseUrl + "print/invoice-report-print?date=" + this.date +
          "&user_id=null" + "&login_user_id=" + this.login_user_id);

    },

  },
};
</script>
